import { useEffect, useRef, useState } from 'react';
import { Input, Space } from 'antd';
import { BaseButton, DeleteButton } from 'components/elements';
import { postSaveFileAPI } from 'api/common';

export const UploadFile = ({ disabled = false, fileName, onChange, onDelete, inputSize = null, fileType=false }) => {
  const fileRef = useRef(null);
  const [name, setName] = useState(fileName);

  useEffect(() => {
    setName(fileName);
  }, [fileName]);

  const handleClick = () => {
    fileRef.current.click();
  };

  const handleChange = async (e) => {
    const formData = new FormData();
    formData.append('upload', e.target.files[0]);
    
    //특정 파일 타입등록하기
    if(fileType && !(e.target.files[0].type).includes(fileType)) {
      alert(`${fileType} 파일을 등록해주세요. `);
      return false;
    }

    await postSaveFileAPI(formData)
      .then((res) => {
        const { data } = res;
        setName(data?.origin_file_name);
        onChange({ origin_file_name: data?.origin_file_name, file_path: data?.file_path });
      })
      .catch((err) => console.error(err))
      .finally(() => {
        e.target.value = '';
      });
  };

  const handleDelete = () => {
    setName(null);
    onDelete();
  };

  return (<>
    <input
      type="file"
      ref={fileRef}
      onChange={handleChange}
      style={{ display: 'none' }}
    />
    <Space>
      <BaseButton disabled={disabled} label={'파일선택'} onClick={handleClick} />
      <Input style={{ width: inputSize }} value={name || '선택된 파일 없음'} disabled={true} />
      {!disabled && <DeleteButton disabled={false} onClick={handleDelete} />}
    </Space>
  </>)
};
